/**
 * Boxystraps product upsell – Shopify Product Recommendations API
 * Replaces Monk upsell widgets on product pages.
 */
(function () {
  const containers = document.querySelectorAll('[data-boxy-upsell]');
  if (!containers.length) return;

  const moneyFormat = window.Shopify?.currency?.active
    ? new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify.currency.active,
      })
    : null;

  function formatMoney(cents) {
    if (moneyFormat) return moneyFormat.format(cents / 100);
    return (cents / 100).toFixed(2);
  }

  function isEbook(product) {
    const handle = (product.handle || '').toLowerCase();
    const title = (product.title || '').toLowerCase();
    return handle.includes('ebook') || title.includes('ebook');
  }

  function prioritizeProducts(products, currentProductId, limit) {
    const filtered = products.filter((p) => String(p.id) !== String(currentProductId));
    const physical = filtered.filter((p) => !isEbook(p));
    const pool = physical.length >= Math.min(limit, 2) ? physical : filtered;
    return pool.slice(0, limit);
  }

  function renderProduct(card, product) {
    const image = product.featured_image || (product.images && product.images[0]);
    const imageUrl = image ? (typeof image === 'string' ? image : image.src) : '';
    const variant = product.variants?.find((v) => v.available) || product.variants?.[0];
    const productUrl = product.url || `/products/${product.handle}`;

    card.innerHTML = `
      <div class="boxy-upsell__media">
        <img class="boxy-upsell__image" src="${imageUrl}" alt="${product.title}" loading="lazy" width="300" height="300">
      </div>
      <div class="boxy-upsell__body">
        <h3 class="boxy-upsell__title"><a href="${productUrl}">${product.title}</a></h3>
        <span class="boxy-upsell__price">${formatMoney(product.price)}</span>
        ${
          variant
            ? `<button type="button" class="boxy-upsell__button" data-variant-id="${variant.id}">Add to cart</button>`
            : ''
        }
      </div>
    `;

    const button = card.querySelector('.boxy-upsell__button');
    if (button && variant) {
      button.addEventListener('click', async () => {
        button.disabled = true;
        button.textContent = 'Adding...';
        try {
          await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
          });
          button.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch {
          button.textContent = 'Error';
          button.disabled = false;
        }
      });
    }
  }

  async function fetchApiRecommendations(productId, intent, limit) {
    const url = `${window.Shopify?.routes?.root || '/'}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`;
    const response = await fetch(url);
    if (!response.ok) return [];
    const data = await response.json();
    return data.products || [];
  }

  async function fetchCollectionProducts(handle, currentProductId, limit) {
    if (!handle) return [];
    const url = `${window.Shopify?.routes?.root || '/'}collections/${handle}/products.json?limit=${limit + 1}`;
    const response = await fetch(url);
    if (!response.ok) return [];
    const data = await response.json();
    return (data.products || [])
      .filter((p) => String(p.id) !== String(currentProductId))
      .slice(0, limit);
  }

  function hideSection(container) {
    const section = container.closest('.shopify-section');
    if (section) section.style.display = 'none';
  }

  function renderProducts(grid, products) {
    grid.innerHTML = '';
    grid.dataset.count = String(products.length);
    products.forEach((product) => {
      const card = document.createElement('article');
      card.className = 'boxy-upsell__card';
      renderProduct(card, product);
      grid.appendChild(card);
    });
  }

  async function loadRecommendations(container) {
    const grid = container.querySelector('[data-boxy-upsell-grid]');
    const productId = container.dataset.productId;
    const intent = container.dataset.intent || 'related';
    const limit = parseInt(container.dataset.limit, 10) || 4;
    const fallbackCollection = container.dataset.fallbackCollection || '';

    if (!productId || !grid) return;

    try {
      let products = await fetchApiRecommendations(productId, intent, limit);

      if (!products.length && intent === 'complementary') {
        products = await fetchApiRecommendations(productId, 'related', limit);
      }

      if (!products.length && fallbackCollection) {
        products = await fetchCollectionProducts(fallbackCollection, productId, limit);
      }

      if (!products.length) {
        products = await fetchCollectionProducts('all', productId, limit);
      }

      products = prioritizeProducts(products, productId, limit);

      if (!products.length) {
        hideSection(container);
        return;
      }

      renderProducts(grid, products);
    } catch {
      hideSection(container);
    }
  }

  containers.forEach(loadRecommendations);
})();
